import { Config, Stage } from '@3fourteen/core';
import { useQuery } from '@tanstack/react-query';

import { IS_PRODUCTION } from 'services/environment';

export function useCustomResearch(filename?: string) {
  const stage = IS_PRODUCTION ? Stage.prod : Stage.dev;
  const actualFilename = filename || 'index.html';

  const { data, ...rest } = useQuery({
    queryKey: ['custom-research', actualFilename],
    queryFn: async () => {
      const res = await fetch(`${Config[stage].apiUrl}/custom-research/${actualFilename}`, {
        method: 'GET',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'text/plain',
        },
        credentials: 'include',
      });

      if (!res.ok) {
        // Try to extract error message from JSON response
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const errorBody = await res.json();
          throw new Error(errorBody.error?.message || 'Failed to fetch custom research');
        } else {
          throw new Error(`Failed to fetch custom research: ${res.status} ${res.statusText}`);
        }
      }

      // Handle signed-url response (used for large HTML files to bypass API Gateway 6MB limit)
      const contentType = res.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        const json = await res.json();
        if (json.type === 'signed-url' && json.url) {
          const htmlRes = await fetch(json.url);
          return await htmlRes.text();
        }
      }

      const html = await res.text();
      return html;
    },
    enabled: !!filename, // Only run query if filename is provided
  });

  return {
    data,
    ...rest,
  };
}
